import type { ComponentType } from "react"

import { Alert, Button } from "@productlane/ui"

// The state an admin lands on from the cap email: AI has stopped. One sentence
// for what happened, the reset date, and one button big enough to be the only
// thing they have to find.
export function UsageGuard({
	title,
	description,
	actionLabel,
	onAction,
	icon,
}: {
	title: string
	description: string
	actionLabel?: string
	onAction?: () => void
	icon?: ComponentType<{ className?: string }>
}) {
	return (
		<Alert
			variant="warning"
			header={title}
			icon={icon}
			data-testid="usage-guard"
		>
			<div className="flex flex-col items-start gap-3">
				<span>{description}</span>
				{actionLabel && onAction && (
					<Button size="lg" onClick={onAction}>
						{actionLabel}
					</Button>
				)}
			</div>
		</Alert>
	)
}
